import { render, staticRenderFns } from "./FolderDeletePopUp.vue?vue&type=template&id=2d781bb4&scoped=true"
import script from "./FolderDeletePopUp.vue?vue&type=script&lang=js"
export * from "./FolderDeletePopUp.vue?vue&type=script&lang=js"
import style0 from "./FolderDeletePopUp.vue?vue&type=style&index=0&id=2d781bb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d781bb4",
  null
  
)

export default component.exports